import type { ExcelAction } from "./types";
import { scanCellTypes } from "../../celltypes/scanner";
import { openCellTypesDialog } from "../dialog-host";

export const findCellTypes: ExcelAction = {
  id: "find-cell-types",
  label: "Identify cell types",
  description:
    "Tag every non-empty cell with its likely type using direct detection (value type, format, value range) and usage inference (how the cell is referenced by formulas). Conflicting signals are flagged.",
  async run({ log }) {
    log("scanning workbook for cell types...");
    let scanResult;
    try {
      scanResult = await scanCellTypes();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`scan failed: ${message}`, "error");
      return;
    }
    const { reports, config, uncatalogued } = scanResult;
    const conflictCount = reports.filter((r) => r.conflict).length;
    const sheetCount = new Set(reports.map((r) => r.sheetName)).size;
    const uncataloguedPart =
      uncatalogued.length > 0
        ? `, ${uncatalogued.length.toLocaleString()} uncatalogued function${uncatalogued.length === 1 ? "" : "s"}`
        : "";
    log(
      `found ${reports.length.toLocaleString()} typed cell(s) across ${sheetCount} sheet(s)` +
        (conflictCount > 0 ? `, ${conflictCount.toLocaleString()} with conflicts` : "") +
        uncataloguedPart,
      reports.length > 0 ? "success" : "info"
    );
    try {
      await openCellTypesDialog(reports, config, uncatalogued);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`dialog failed: ${message}`, "error");
    }
  },
};
